import { motion } from 'framer-motion'

// Components
import PublishingOwner from 'components/interestform/formcomponents/publishingowner'
import ContactPerson from 'components/interestform/formcomponents/contactperson'

// Types
import { PageVariants } from 'types'

// Utils
import commonStyles from 'components/interestform/slides/common.css'
import styles from './rightsinformation.css'

type RightsInformationProps = {
  values: {
    publishing_owner: string
  }
  pageVariants: PageVariants
}

const RightsInformation = (props: RightsInformationProps): JSX.Element => {
  const {
    values: { publishing_owner },
    pageVariants,
  } = props

  let publishing_cat
  switch (publishing_owner) {
    case 'self_owned':
      publishing_cat = 1
      break
    case 'self_and_external_owned':
      publishing_cat = 2
      break
    case 'self_and_publishing_administrator':
      publishing_cat = 1
      break
    case 'unpublished':
      publishing_cat = 1
      break
    case 'external_owned':
      publishing_cat = 2
      break
    default:
      publishing_cat = undefined
      break
  }

  return (
    <motion.div className={commonStyles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <h1 className={styles.heading}>
        Rights Information
        <span className={styles.requiredStar}>*</span>
      </h1>
      <div className={styles.subheading}>
        Next we need to know about your catalog and who owns it! Tell us about who owns the master and publishing rights, and where we can
        send agreements to
      </div>
      <div>
        <div className={styles.questionWrapper}>
          <div className={styles.questionTitle}>Master rights</div>
          <div className={styles.questionDetails}>Tell us who we should send the master agreement to</div>
          <ContactPerson onReview={false} typeOfRights="master" />
        </div>
        <div className={styles.questionWrapper}>
          <div className={styles.questionTitle}>How are the publishing rights for your music handled?</div>
          <PublishingOwner onReview={false} publishingOwner={publishing_owner} />
        </div>
        <div className={styles.questionWrapper}>
          <div className={styles.questionTitle}>Publishing rights</div>
          <div className={styles.questionDetails}>
            {publishing_cat && publishing_cat === 1
              ? 'Tell us who we should send the composition agreement to'
              : 'Tell us what email we should contact to understand who owns the publishing rights'}
          </div>
          <ContactPerson onReview={false} typeOfRights="publishing" />
        </div>
      </div>
    </motion.div>
  )
}

export default RightsInformation
